// This was used by IWannaTicket, therefore possibly not needed anymore
// ties to HTML defined in _Layout.cshtml
// May have also been used by TripPlanner ? Doesn't appear to be anymore.

import Component from './Component';

export default class ModalIframe extends Component {
  load() {
    this.$backdrop = null;
    this.$container = null;
    this.$closeButton = null;
    this.iframeId = null;
    // console.log('ModalIframe load');
    this.initModal();
    super.load();
  }

  initModal() {
    // console.log('init ModalIframe component');
    var self = this;

    if (self.$backdrop === null || self.$backdrop === undefined) {
      self.$backdrop = $('.modal-iframe__backdrop');
      // console.log('Backdrop', self.$backdrop);
    }

    if (self.$container === null || self.$container === undefined) {
      self.$container = $('.modal-iframe__container');
      // console.log('container', self.$container);
    }

    if (self.$closeButton === null || self.$closeButton === undefined) {
      self.$closeButton = $('.modal-iframe__container__close-btn');
      // console.log('closeButton', self.$closeButton);
    }

    if (self.iframeId == null) {
      self.iframeId = 'modalIframe';
      // console.log('iframeId', self.iframeId);
    }

    if (!self.$backdrop.hasClass('js-done')) {
      self.$backdrop.on('click', function () {
        self.close();
      });
      self.$backdrop.addClass('js-done');
    }

    if (!self.$closeButton.hasClass('js-done')) {
      self.$closeButton.on('click', function (e) {
        e.preventDefault();
        self.close();
      });
      self.$closeButton.addClass('js-done');
    }

    var $buttons = $('.open-iframe-modal:not(.js-done)');
    // console.log('button count: ' + $buttons.length);
    $buttons.each(function () {
      var $this = $(this);
      // console.log('modal button this:', this);
      // console.log('has class js-done? ', $this.hasClass('js-done'));
      $this.on('click', function (e) {
        // console.log('ModalIframe click this:', this);
        var iframeSrc = $this.attr("data-iframe-src");
        // console.log('iframe-src:', iframeSrc);
        e.preventDefault();
        // console.log('self.iframeId:', self.iframeId);
        $('<iframe>', {
          src: iframeSrc,
          id: self.iframeId
        }).appendTo(self.$container);
        // console.log('self:', self);
        // console.log('self.$container:', self.$container);
        self.$backdrop.css("display", "block");
        self.$container.css("display", "block");
        window.scrollTo(0, 0);
      });
      $this.addClass('js-done');
    });

  }


  close() {
    // console.log('ModalIframe close');
    var self = this;
    self.initModal();

    if (self.$container.css("display") == "block") {
      self.$container.css("display", "none");
      self.$backdrop.css("display", "none");
      self.$backdrop.className = '';

      var $iframe = self.$container.find('iframe');
      $iframe.remove();
    }
  }

}
